import type { ReactNode } from 'react'
import { clsx } from 'clsx'

// Surface card — the default container for content blocks + list rows.
export function Card({
  children,
  className,
  onClick,
  as,
}: {
  children: ReactNode
  className?: string
  onClick?: () => void
  as?: 'div' | 'button'
}) {
  const Tag = as ?? (onClick ? 'button' : 'div')
  return (
    <Tag
      onClick={onClick}
      className={clsx(
        'block w-full text-left bg-[var(--surface-card)] border border-[var(--line)] rounded-[var(--radius-card)]',
        'shadow-[var(--shadow-flat)]',
        onClick && 'active:scale-[0.99] transition-transform',
        className,
      )}
    >
      {children}
    </Tag>
  )
}
